module.exports = __webpack_public_path__ + "static/media/2018-11-29_Bordallo-2090_bw_half_blur.ad3964f0.jpg";